import { Divider, Stack } from '@mui/material';
import { areSelectedSessionCalibratedQuery, selectedSessionIdsQuery } from '../../../core/sessions/queries';
import { useAppSelector } from '../../../types';
import { AnalyzeAIOnSelectedSessionsButton } from '../../design_system/inputs/buttons/AnalyzeAIOnSelectedSessionsButton';
import { CalibrateSelectedSessionsButton } from '../../design_system/inputs/buttons/CalibrateSelectedSessionsButton';
import { UploadSessionsButton } from '../../design_system/inputs/buttons/UploadSessionsButton';
import SessionExportsMenu from './Menu/ExportsMenu';
import ComputeHomogeneousZones from '../../design_system/inputs/buttons/ComputeHomogeneousZones';
import DispatchButton from '../../design_system/inputs/buttons/DispatchButton';

export const ActionsOnSelectedSessions = () => {
    const areSessionCalibrated = useAppSelector(areSelectedSessionCalibratedQuery);
    const sessionsIds = useAppSelector(selectedSessionIdsQuery);

    return (
        <Stack sx={{ flexDirection: 'row', justifyContent: 'flex-end', m: 1.5 }}>
            {sessionsIds && sessionsIds.length > 0 && (
                <>
                    <Stack direction="row" gap={1}>
                        <CalibrateSelectedSessionsButton calibrated={areSessionCalibrated} sessionIds={sessionsIds} />
                        <AnalyzeAIOnSelectedSessionsButton calibrated={areSessionCalibrated} sessionIds={sessionsIds} />
                        <DispatchButton title="session.edit_campaign" modalType="SESSIONS_EDIT_CAMPAIGN" />
                        <DispatchButton title="session.edit_state" modalType="SESSIONS_EDIT_STATE" />
                        <ComputeHomogeneousZones calibrated={areSessionCalibrated} />
                        <SessionExportsMenu sessionIds={sessionsIds} />
                    </Stack>
                    <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />
                </>
            )}
            <UploadSessionsButton />
        </Stack>
    );
};
